import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Unified search input component
 *
 * @param {string} value - Current input value
 * @param {function} onChange - Called with new value on change
 * @param {string} placeholder - Placeholder text
 * @param {string} variant - "box" (with background) or "underline" (transparent with border-bottom)
 * @param {function} onEnter - Optional callback when Enter key is pressed
 * @param {string} className - Additional classes for the container
 */
const SearchInput = ({
  value,
  onChange,
  placeholder = "Search...",
  variant = "underline",
  onEnter,
  className = "",
}) => {
  const handleKeyPress = e => {
    if (e.key === "Enter" && onEnter) {
      onEnter();
    }
  };

  const inputClasses = variant === "box"
    ? "w-full pl-9 pr-4 py-2.5 text-sm bg-base-200 border border-base-content/10 rounded-lg focus:outline-none focus:border-primary"
    : "w-full pl-5 pr-3 py-2 text-sm bg-transparent border-b border-black/15 focus:outline-none focus:border-[#c76f31] transition-colors";

  const iconClasses = variant === "box"
    ? "absolute left-3 top-1/2 -translate-y-1/2 text-base-content/30 text-xs"
    : "absolute left-0 top-1/2 -translate-y-1/2 text-base-content/30 text-xs";

  return (
    <div className={`relative ${className}`}>
      <FontAwesomeIcon
        icon={faMagnifyingGlass}
        className={iconClasses}
      />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyPress={handleKeyPress}
        className={inputClasses}
      />
    </div>
  );
};

export default SearchInput;
